import React, { Component, Fragment } from "react";
import { NavLink } from "react-router-dom";
import Header from "../account/Header";
import AccountNav from "../account/AccountNav";
import BillingList from "./BillingList";
import Footer from "../../utilities/Footer";
import AppContext from "../../../contexts/AppContext";
import NoData from "../../utilities/NoData";
import LoadingData from "../../utilities/LoadingData";
import {
    records,
    record,
    remove,
    search,
    update,
    create
} from "../../../services/billing";
export class Billing extends Component {
    state = {
        items: [],
        meta: {},
        query: "",
        search: false,
        create: false,
        loading: true,
        tableCount: "hide",
        filterItem: "all"
    };

    delete = id => {
        return remove(id).then(response => {
            let temp = this.state.items;
            for (var i in temp) {
                if (temp[i].id === id) {
                    temp.splice(i, 1);
                    this.setState({ items: temp });
                }
            }
        });
    };

    update = (id, item) => {
        return update(id, item).then(response => {
            let temp = this.state.items;
            for (var i in temp) {
                if (temp[i].id === id) {
                    temp[i] = response.data;
                    this.setState({ items: temp });
                }
            }
        });
    };

    create = item => {
        return create(item).then(response => {
            let temp = this.state.items;
            temp.unshift(response.data);
            this.setState({ items: temp });
        });
    };

    toggleCreate = () => {
        this.setState({ create: this.state.create === true ? false : true });
    };

    toggleTableCount = () => {
        this.setState({
            tableCount: this.state.tableCount === "hide" ? "show" : "hide"
        });
    };
    record = id => {
        return record(id);
    };
    onQueryChange = field => {
        this.setState({ query: field.target.value });
    };
    search = query => {
        this.setState({ loading: true });
        search(query).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                search: true,
                query: query,
                loading: false
            });
        });
    };

    clear = () => {
        this.setState({ loading: true });
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    search: false,
                    filter: false,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };

    componentDidMount() {
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    loading: false
                });
                console.log(this.state.items);
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    changePage = page => {
        if (this.state.search === true) {
            search(this.state.query, page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        } else {
            records(page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        }
    };
    submitSearch = e => {
        e.preventDefault();
        if (this.state.query.length >= 1) {
            this.search(this.state.query);
        } else {
            this.clear();
        }
    };

    render() {
        return (
            <Fragment>
                        <Header></Header>
                <div>
				    {/* <section className="dashboard-nav">
		                <div className="container">
		            	    <div className="head">
		            		    <h1>Settings</h1>
		            		</div>		            		
		            		<AccountNav></AccountNav>
		            	</div>
		            </section> */}
					<section className="settingsDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 mt-4">
						<div className="container writer-container">
							<div className="row">
								<div className="col-md-3">
							        <div className="card custom">
							            <div className="card-header">
							        	    Settings
							            </div>
                                        <div className="card-body">									
							        	    <nav className="custom-sidenav" id="myScrollspy">
                                            	<ul className="list-group">														
													<li><NavLink to={`/account/settings`} exact={true}>My Account</NavLink></li>
													<li><NavLink to={`/account/settings/membership`} exact={true}>Membership</NavLink></li>
													<li><NavLink to={`/account/settings/credits`} exact={true}>Credits</NavLink></li>
													<li><NavLink to={`/account/settings/payment-methods`} exact={true}>Payment Methods</NavLink></li>
													<li className='active'><NavLink to={`/account/settings/billing-history`} exact={true}>Billing History</NavLink></li>
                                            	</ul>
                                            </nav>
							        	</div>
							        </div>	
							    </div>
								<div className="col-md-9 mt-md-0 mt-4">									
                                    <div className="header">
                                        <div className="header-body">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h1 className="header-title">
                                                    Billing History
                                                    </h1>
                                                
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div className="table-responsive">
                                            {this.state.loading === true ? (
                                                <LoadingData></LoadingData>
                                            ) : this.state.items.length >= 1 ? (
                                                <table className="table table-sm table-nowrap card-table">
                                                    <thead>
                                                        <tr>
                                                            {/*<th>
                                                                <div className="custom-control custom-checkbox table-checkbox">
                                                                    #
                                                                </div>
                                                            </th>*/}
                                                            <th className="w-25">Product</th>
                                                            <th>Price</th>
                                                            <th>Payment Method</th>
                                                            <th>Status</th>
                                                            <th>Purchase Date</th>                                                            
                                                        
                                                        </tr>
                                                    </thead>
                                                    <tbody className="list">
                                                        {this.state.items.map(
                                                            (item, index) => {
                                                                return (
                                                                    <BillingList
                                                                        getItem={
                                                                            this
                                                                                .record
                                                                        }
                                                                        item={item}
                                                                        index={
                                                                            index
                                                                        }
                                                                        key={index}
                                                                    ></BillingList>
                                                                );
                                                            }
                                                        )}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <NoData></NoData>
                                            )}
                                        </div>
                                        {/*<div>
                                            <Footer
                                                changePage={this.changePage}
                                                totalPages={this.state.meta.pages}
                                                curentPage={this.state.meta.page}
                                            ></Footer>
	                                    </div>*/}
                                    </div>
								</div>
							</div>
						</div>
					</section>
				</div>
            </Fragment>
        );
    }
}
Billing.contextType = AppContext;
export default Billing;



// WEBPACK FOOTER //
// ./src/components/writer/billing/Billing.js